import { differenceInYears } from "date-fns";

export function isJunior(birthDate: string | null | undefined): boolean {
  if (!birthDate) return false;
  return differenceInYears(new Date(), new Date(birthDate)) < 18;
}

export function getAge(birthDate: string | null | undefined): number | null {
  if (!birthDate) return null;
  return differenceInYears(new Date(), new Date(birthDate));
}

export function getAgeCategory(birthDate: string | null | undefined): string | null {
  const age = getAge(birthDate);
  if (age === null) return null;
  if (age < 10) return "junior_u10";
  if (age < 12) return "junior_u12";
  if (age < 14) return "junior_u14";
  if (age < 16) return "junior_u16";
  if (age < 18) return "junior_u18";
  return "adult";
}
